import React from 'react';
import { PurchaseRequests } from 'components/app/erp/purchase-request';

// Route-level page entry for ERP Procurement → Purchase Requisitions (list).
const PurchaseRequisitionsPage = () => <PurchaseRequests />;

export default PurchaseRequisitionsPage;
